import { createValidator, ErrorObject, required, richTextMaxLength } from 'util/validation'

import { IntervencoesProcedimentosPlanoModel } from '../components/IntervencoesProcedimentosView'
import { PlanoFormModel } from '../PlanoForm'

export const intervencoesProcedimentosPlanoValidator = createValidator<IntervencoesProcedimentosPlanoModel>(
  {},
  (values: IntervencoesProcedimentosPlanoModel, errors: ErrorObject<IntervencoesProcedimentosPlanoModel>) => {
    errors.procedimentosPlano = { procedimentos: required(values?.procedimentosPlano?.procedimentos) }
    return errors
  }
)

export const planoProcedimentosValidator = () =>
  createValidator<PlanoFormModel>({
    texto: [richTextMaxLength(4000)],
    intervencoesProcedimentos: intervencoesProcedimentosPlanoValidator,
  })
